import { useCallback } from 'react';
// eslint-disable-next-line import/extensions
import { useSwiper } from 'swiper/react';
import c from 'classnames';
import styles from './styles.scss';
// eslint-disable-next-line import/extensions
import 'swiper/css';
import PropTypes from 'prop-types';

const propTypes = {
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(['left', 'right']),
  isModal: PropTypes.bool,
};

const SliderArrowButton = ({ disabled, direction, isModal }) => {
  const swiper = useSwiper();
  const currentClassName = c(styles.wrapper, {
    [styles.disabled]: disabled,
    [styles.right]: direction === 'right',
    [styles.modal]: isModal,
    'generic-arrow': true,
  });
  const arrowClassName = c(styles.icon, { [styles.left]: direction === 'left' });

  const handleClick = useCallback(() => {
    if (direction === 'right') {
      return !swiper.isEnd && swiper.slideNext();
    }
    return !swiper.isBeginning && swiper.slidePrev();
  }, [direction, swiper]);

  return (
    <div className={currentClassName} onClick={handleClick}>
      <img src="https://cdn.ticketspot.io/widget/layout-icons/shared/arrow.svg" className={arrowClassName} alt="x" />
    </div>
  );
};

SliderArrowButton.propTypes = propTypes;

export default SliderArrowButton;
